export default class IOSProvider {
  constructor (data) {
    this.id = data.id;
    this.teamId = data.teamId;
    this.keyId = data.keyId;
    this.bundleId = data.bundleId;
    this.appId = data.appId;
    this.p8 = data.p8;
    this.createdBy = data.createdBy;
    this.createdAt = data.createdAt;
    this.updatedBy = data.updatedBy;
    this.updatedAt = data.updatedAt;
  }
}
